import { render, staticRenderFns } from "./VariantSifterAssociationsFilters.vue?vue&type=template&id=6a492fbe&scoped=true&"
import script from "./VariantSifterAssociationsFilters.vue?vue&type=script&lang=js&"
export * from "./VariantSifterAssociationsFilters.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterAssociationsFilters.vue?vue&type=style&index=0&id=6a492fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a492fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a492fbe')) {
      api.createRecord('6a492fbe', component.options)
    } else {
      api.reload('6a492fbe', component.options)
    }
    module.hot.accept("./VariantSifterAssociationsFilters.vue?vue&type=template&id=6a492fbe&scoped=true&", function () {
      api.rerender('6a492fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterAssociationsFilters.vue"
export default component.exports